module.exports = __webpack_public_path__ + "images/smartphone-screen-3_251a179ca81a0e3d35d794f925716a7d.png";